/* MV Sortiment assets/mv-sortiment.akademie.js - Agent W-A - 2026-10-07
 *
 * Akademie (sections/mv-akademie.liquid, sections/mv-lernpfad.liquid; Spezifikation _docs/wa-akademie.md).
 * Lernpfad, Wurzel [data-mv-akademie="pfad"] mit data-mv-lernpfad (Handle), data-mv-lernpfad-kapitel (Kennungen in
 * Kapitelfolge) und data-mv-lernpfad-titel:
 *  1. Stand je Lernpfad ueber MVKonto (assets/mv-sortiment.konto.js, Paket A-2a) unter dem Werkzeug-Schluessel
 *     "akademie-<handle>" als {"v":1,"fertig":["kennung"],"antworten":{"kennung":[1,0,3]},"titel":"<Lernpfad>",
 *     "kapitel":"<zuletzt bearbeitet>"} (0 = unbeantwortet): im Browser-Spiegel mv-konto:akademie-<handle>, mit
 *     Login zusaetzlich im Kundenkonto. Der zuletzt bearbeitete Pfad ist der mit dem juengsten Stand (kapitel).
 *     Altstaende mv-akademie:<handle> und mv-akademie:zuletzt uebernimmt MVKonto einmalig. Ohne nutzbaren Speicher
 *     gilt der Stand nur fuer die geoeffnete Seite. Kein eigener Netzzugriff, keine Analytics.
 *  2. Formular [data-mv-lernpfad-test] je Kapitel: Absenden prueft die drei Radiogruppen gegen data-mv-lernpfad-richtig.
 *     Unvollstaendig = Hinweis ohne Speichern; sonst Rueckmeldung je Frage, Erklaerung bei falscher Antwort, Ergebnis,
 *     Antworten gespeichert; alle richtig schliesst das Kapitel ab. Eine neue Auswahl blendet die alte Rueckmeldung aus.
 *  3. Haken [data-mv-lernpfad-fertig] (aria-pressed) schaltet ein Kapitel um. Kapitel, Leiste, Ring, Fortschritt,
 *     Start-Knopf, Lernstand und Anfrage-Text (data-konfiguration) folgen dem Stand; [data-mv-lernpfad-ansage] sagt an.
 *  4. Leiste, Start und Wege ([data-mv-lernpfad-leiste-ziel], [data-mv-lernpfad-start], [data-mv-lernpfad-gehe])
 *     scrollen zum Ziel (sanft, ausser bei reduzierter Bewegung) und setzen den Fokus auf dessen Ueberschrift
 *     (id + "-titel", tabindex -1). Die Leiste markiert das sichtbare Kapitel (aria-current, IntersectionObserver).
 *  5. [data-mv-lernpfad-drucken] druckt nur den Lernstand (Attribut data-mv-lernpfad-druck an html bis afterprint).
 *  6. [data-mv-lernpfad-zuruecksetzen] loescht den Stand des Lernpfads.
 * Hub, Wurzel [data-mv-akademie="hub"]:
 *  7. Je Karte [data-mv-akademie-karte] Ring, Fortschritt, Kapitelhaken und Linktext aus dem Stand.
 *  8. Einstieg [data-mv-akademie-weiter]: Weiterlernen im zuletzt bearbeiteten, sonst im ersten begonnenen Pfad, dazu
 *     der Gesamtstand; ohne Fortschritt bleibt der Einstieg aus dem Markup (Lernpfad 1).
 * Paket T-1 (2026-10-07, Querpruefung R-1, Abschnitt 5): Haken und Farbe zeigen "abgeschlossen" in der Leiste des
 *     Lernpfads und in der Kapitelliste des Hubs nur optisch; abgeschlossene Eintraege bekommen deshalb einen
 *     verborgenen Zusatz ", abgeschlossen" (span.mv-visually-hidden mit data-mv-zustand-zusatz, entsteht hier), die
 *     Ziffer der Leiste bleibt im Namen (akademie.css verdeckt sie nur optisch).
 * Delegation auf document; shopify:section:load startet neu, pageshow (Zurueck-Taste) und ein anderer Tab
 * (MVKonto-Ereignis extern) frischen den Stand auf. Laedt allein und in beliebiger Reihenfolge als Teil von
 * assets/mv-sortiment.js (_build/konkat.sh). Unter Node (Tests) liefert die Datei nur die reinen Funktionen.
 * Kommentare und Datei ASCII; sichtbare Texte als \u-Escapes.
 * Nachtrag A-2a (2026-10-10, _docs/a2a-konto-speicherschicht.md): Speicher nur noch ueber MVKonto (lokal, speichern,
 *     loeschen, lesen), Seitenstand im Zwischenspeicher je Pfad. Die Konto-Schicht steht im Buendel nach dieser Datei,
 *     darum startet das Modul erst nach dem Buendel (Mikrotask). Mit Login holt es nach dem ersten Zeichnen den Stand
 *     aus dem Konto und zeichnet neu, wenn er abweicht (offene Auswahl in den Fragen bleibt stehen, sobald gewaehlt
 *     wurde; wurde vor der Antwort schon geprueft, abgehakt oder zurueckgesetzt, gilt das und geht ins Konto).
 *     Statuszeile [data-mv-konto-hinweis] im Kopf: Lernpfad mit seinem Schluessel, Uebersicht mit allen.
 *     Ohne MVKonto gilt der Stand nur fuer die Seite. Sichtbares Verhalten ohne Login wie vorher.
 */
;(function () {
  'use strict';

  var VERSION = '2026-10-10.1';
  var PRAEFIX = 'mv-akademie:';
  var ZULETZT = PRAEFIX + 'zuletzt';
  var KENNUNG = /^[a-z0-9]+(?:-[a-z0-9]+)*$/;
  var FRAGEN = 3;

  var TEXT = {
    keinKapitel: 'Noch kein Kapitel abgeschlossen',
    vonKapiteln: '{n} von {m} Kapiteln abgeschlossen',
    alle: 'Alle Kapitel abgeschlossen',
    pfadFertig: 'Lernpfad abgeschlossen',
    starten: 'Lernpfad starten',
    weiter: 'Weiter mit Kapitel {n}',
    ansehen: 'Lernstand ansehen',
    weiterlernen: 'Weiterlernen',
    ergebnis: '{n} von {m} Fragen richtig',
    ergebnisAlle: 'Alle {m} Fragen richtig',
    unvollstaendig: 'Bitte beantworten Sie alle drei Fragen.',
    richtig: 'Richtig.',
    falsch: 'Nicht ganz. Richtig ist: {t}',
    erklaerungen: 'Die Erkl\u00e4rungen stehen bei den Fragen.',
    abgeschlossen: 'abgeschlossen',
    fertigZusatz: ', abgeschlossen',
    offen: 'offen',
    ungeprueft: 'noch nicht gepr\u00fcft',
    kapitelFertig: 'Kapitel {n} abgeschlossen',
    kapitelOffen: 'Kapitel {n} wieder offen',
    zurueck: 'Fortschritt zur\u00fcckgesetzt',
    anfrage: 'Lernpfad: {t}',
    anfrageStand: ' \u00b7 Kapitel abgeschlossen: {n} von {m}',
    summe: '{k} \u00b7 {r} von {f} Fragen richtig beantwortet',
    weiterTitel: 'Weiterlernen: {t}',
    weiterKapitel: 'Kapitel {n}: {t}',
    alleFertigTitel: 'Alle Lernpfade abgeschlossen',
    alleFertigText: 'Sie haben jedes Kapitel der Akademie abgeschlossen. Ihren Lernstand finden Sie auf der Seite jedes Lernpfads.',
    gesamt: '{n} von {m} Kapiteln in allen Lernpfaden abgeschlossen'
  };

  // ===========================================================================================
  // Teil 1: reine Logik
  // ===========================================================================================

  function istListe(x) {
    return Object.prototype.toString.call(x) === '[object Array]';
  }

  function hat(obj, k) {
    return !!obj && Object.prototype.hasOwnProperty.call(obj, k);
  }

  // Platzhalter {x} ersetzen (Funktion als Ersatz: Werte bleiben woertlich)
  function fuelle(text, werte) {
    return String(text).replace(/\{(\w)\}/g, function (m, k) {
      return hat(werte, k) ? String(werte[k]) : m;
    });
  }

  function leererStand() {
    return { v: 1, fertig: [], antworten: {} };
  }

  function schluessel(pfad) {
    return PRAEFIX + String(pfad == null ? '' : pfad);
  }

  // Antworten eines Kapitels: genau drei Eintraege, je 1 bis 3 oder 0 (unbeantwortet); sonst null
  function leseAntworten(x) {
    if (!istListe(x) || x.length !== FRAGEN) return null;
    var aus = [];
    for (var i = 0; i < FRAGEN; i++) {
      var n = x[i];
      aus.push(typeof n === 'number' && n >= 1 && n <= 3 && Math.floor(n) === n ? n : 0);
    }
    return aus;
  }

  function fertigVon(stand) {
    return stand && istListe(stand.fertig) ? stand.fertig : [];
  }

  function antwortenVonStand(stand) {
    return stand && stand.antworten && typeof stand.antworten === 'object' && !istListe(stand.antworten) ? stand.antworten : {};
  }

  // Gespeicherten Text lesen; alles Unbekannte faellt weg (Kennungen a-z0-9-, je Kapitel drei Antworten)
  function leseStand(roh) {
    var s = leererStand();
    if (typeof roh !== 'string' || !roh) return s;
    var d;
    try { d = JSON.parse(roh); } catch (e) { return s; }
    if (!d || typeof d !== 'object') return s;
    var i;
    if (istListe(d.fertig)) {
      for (i = 0; i < d.fertig.length; i++) {
        var k = d.fertig[i];
        if (typeof k === 'string' && KENNUNG.test(k) && s.fertig.indexOf(k) === -1) s.fertig.push(k);
      }
    }
    var a = antwortenVonStand(d);
    for (var key in a) {
      if (!hat(a, key) || !KENNUNG.test(key)) continue;
      var werte = leseAntworten(a[key]);
      if (werte) s.antworten[key] = werte;
    }
    return s;
  }

  function kopie(stand) {
    var s = { v: 1, fertig: fertigVon(stand).slice(), antworten: {} };
    var a = antwortenVonStand(stand);
    for (var k in a) if (hat(a, k) && istListe(a[k])) s.antworten[k] = a[k].slice();
    return s;
  }

  function standText(stand) {
    var s = kopie(stand);
    return JSON.stringify({ v: 1, fertig: s.fertig, antworten: s.antworten });
  }

  // Kapitel als abgeschlossen setzen oder oeffnen; liefert einen neuen Stand (Reihenfolge des Abschliessens)
  function setzeFertig(stand, kennung, an) {
    var s = kopie(stand);
    var i = s.fertig.indexOf(kennung);
    if (an && i === -1) s.fertig.push(kennung);
    if (!an && i !== -1) s.fertig.splice(i, 1);
    return s;
  }

  function umschalten(stand, kennung) {
    return setzeFertig(stand, kennung, fertigVon(stand).indexOf(kennung) === -1);
  }

  function setzeAntworten(stand, kennung, werte) {
    var s = kopie(stand);
    var a = leseAntworten(werte);
    if (a) s.antworten[kennung] = a;
    else delete s.antworten[kennung];
    return s;
  }

  // Auswertung: je Frage richtig (gewaehlt = richtig), Zahl der richtigen, vollstaendig = alle beantwortet
  function auswerten(antworten, richtige) {
    var je = [];
    var richtig = 0;
    var vollstaendig = true;
    for (var i = 0; i < richtige.length; i++) {
      var a = antworten && typeof antworten[i] === 'number' ? antworten[i] : 0;
      if (!(a >= 1)) vollstaendig = false;
      var ok = a >= 1 && a === richtige[i];
      je.push(ok);
      if (ok) richtig += 1;
    }
    return { richtig: richtig, gesamt: richtige.length, je: je, vollstaendig: vollstaendig };
  }

  function anzahlFertig(stand, kennungen) {
    var f = fertigVon(stand);
    var n = 0;
    for (var i = 0; i < kennungen.length; i++) if (f.indexOf(kennungen[i]) !== -1) n += 1;
    return n;
  }

  function prozent(n, gesamt) {
    return gesamt > 0 ? Math.round((n * 100) / gesamt) : 0;
  }

  function fortschrittText(n, gesamt) {
    if (n <= 0) return TEXT.keinKapitel;
    if (gesamt > 0 && n >= gesamt) return TEXT.alle;
    return fuelle(TEXT.vonKapiteln, { n: n, m: gesamt });
  }

  function kartenText(n, gesamt) {
    if (gesamt > 0 && n >= gesamt) return TEXT.pfadFertig;
    return fuelle(TEXT.vonKapiteln, { n: n, m: gesamt });
  }

  // Erstes offenes Kapitel in Kapitelfolge, '' wenn alle abgeschlossen sind
  function naechstesKapitel(stand, kennungen) {
    var f = fertigVon(stand);
    for (var i = 0; i < kennungen.length; i++) if (f.indexOf(kennungen[i]) === -1) return kennungen[i];
    return '';
  }

  function startText(stand, kennungen) {
    if (anzahlFertig(stand, kennungen) === 0) return TEXT.starten;
    var k = naechstesKapitel(stand, kennungen);
    return k ? fuelle(TEXT.weiter, { n: kennungen.indexOf(k) + 1 }) : TEXT.ansehen;
  }

  function ergebnisText(richtig, gesamt) {
    if (gesamt > 0 && richtig >= gesamt) return fuelle(TEXT.ergebnisAlle, { m: gesamt });
    return fuelle(TEXT.ergebnis, { n: richtig, m: gesamt });
  }

  function statusText(stand, kennung) {
    return fertigVon(stand).indexOf(kennung) !== -1 ? TEXT.abgeschlossen : TEXT.offen;
  }

  // Text fuer die Anfrage-Lightbox (data-konfiguration): Lernpfad und, wenn begonnen, der Stand
  function anfrageText(titel, n, gesamt) {
    var s = fuelle(TEXT.anfrage, { t: titel == null ? '' : titel });
    if (n > 0) s += fuelle(TEXT.anfrageStand, { n: n, m: gesamt });
    return s;
  }

  function zweistellig(n) {
    return (n < 10 ? '0' : '') + n;
  }

  function datumText(d) {
    return zweistellig(d.getDate()) + '.' + zweistellig(d.getMonth() + 1) + '.' + d.getFullYear();
  }

  function leseZuletzt(roh) {
    if (typeof roh !== 'string' || !roh) return null;
    var d;
    try { d = JSON.parse(roh); } catch (e) { return null; }
    if (!d || typeof d !== 'object' || typeof d.pfad !== 'string' || !KENNUNG.test(d.pfad)) return null;
    return { pfad: d.pfad, kapitel: typeof d.kapitel === 'string' && KENNUNG.test(d.kapitel) ? d.kapitel : '' };
  }

  // Empfehlung fuer den Hub. pfade: [{handle, kapitel: [kennung]}] in Hub-Reihenfolge, staende: {handle: Stand},
  // zuletzt: {pfad, kapitel} oder null. Reihenfolge: zuletzt bearbeiteter Pfad (wenn offen), erster begonnener Pfad,
  // erster offener Pfad. null ohne jeden Fortschritt; {pfad: ''} wenn alles abgeschlossen ist.
  function empfehlung(pfade, staende, zuletzt) {
    var st = staende || {};
    var standVon = function (h) { return hat(st, h) ? st[h] : leererStand(); };
    var begonnen = function (p) { return anzahlFertig(standVon(p.handle), p.kapitel) > 0; };
    var vorschlag = function (p) {
      var k = naechstesKapitel(standVon(p.handle), p.kapitel);
      return k ? { pfad: p.handle, kapitel: k, nummer: p.kapitel.indexOf(k) + 1 } : null;
    };
    var i;
    var zl = null;
    var irgendwas = false;
    for (i = 0; i < pfade.length; i++) {
      if (begonnen(pfade[i])) irgendwas = true;
      if (zuletzt && zuletzt.pfad && pfade[i].handle === zuletzt.pfad) zl = pfade[i];
    }
    if (!irgendwas && !zl) return null;
    var e = zl ? vorschlag(zl) : null;
    if (e) return e;
    for (i = 0; i < pfade.length; i++) {
      if (!begonnen(pfade[i])) continue;
      e = vorschlag(pfade[i]);
      if (e) return e;
    }
    for (i = 0; i < pfade.length; i++) {
      e = vorschlag(pfade[i]);
      if (e) return e;
    }
    return { pfad: '', kapitel: '', nummer: 0 };
  }

  // ------------------------------------------------------------------------------- Konto (Paket A-2a)

  var KONTO_PRAEFIX = 'akademie-';

  // Werkzeug-Schluessel laut Vertrag (MVKonto): akademie-<lernpfad-handle>
  function werkzeug(pfad) {
    return KONTO_PRAEFIX + String(pfad == null ? '' : pfad);
  }

  // Stand fuers Konto: Fortschritt, Titel (Uebersicht "Meine Werkzeuge") und zuletzt bearbeitetes Kapitel
  function kontoStand(stand, titel, kapitel) {
    var s = kopie(stand);
    var t = String(titel == null ? '' : titel).replace(/[ \t\n\r\f]+/g, ' ').replace(/^ | $/g, '');
    if (t) s.titel = t.length > 120 ? t.slice(0, 120) : t;
    if (typeof kapitel === 'string' && KENNUNG.test(kapitel)) s.kapitel = kapitel;
    return s;
  }

  // Stand aus einem Objekt (MVKonto) so robust lesen wie aus dem Text; alles Unbekannte faellt weg
  function standAus(objekt) {
    if (!objekt || typeof objekt !== 'object' || istListe(objekt)) return leererStand();
    var text;
    try { text = JSON.stringify(objekt); } catch (e) { return leererStand(); }
    return leseStand(text);
  }

  function kapitelAus(objekt) {
    return objekt && typeof objekt === 'object' && typeof objekt.kapitel === 'string' && KENNUNG.test(objekt.kapitel) ? objekt.kapitel : '';
  }

  // Zuletzt bearbeiteter Pfad (ersetzt den Zeiger mv-akademie:zuletzt): unter den Staenden mit Kapitel der juengste
  // (jede Aktion setzt Kapitel und Zeit; ein uebernommener Altstand traegt das Kapitel nur, wenn der alte Zeiger auf ihn
  // zeigte), sonst der juengste Stand ueberhaupt. eintraege: [{ pfad, kapitel, aktualisiert_am }]; null ohne Treffer.
  function zuletztAus(eintraege) {
    var gueltig = (eintraege || []).filter(function (e) { return e && typeof e.pfad === 'string' && KENNUNG.test(e.pfad); });
    var zeit = function (e) {
      var t = typeof e.aktualisiert_am === 'string' ? Date.parse(e.aktualisiert_am) : NaN;
      return isFinite(t) ? t : -Infinity;
    };
    var mitKapitel = gueltig.filter(function (e) { return typeof e.kapitel === 'string' && KENNUNG.test(e.kapitel); });
    var pool = mitKapitel.length ? mitKapitel : gueltig.filter(function (e) { return zeit(e) > -Infinity; });
    var best = null;
    pool.forEach(function (e) {
      if (!best || zeit(e) > zeit(best)) best = e;
    });
    return best ? { pfad: best.pfad, kapitel: kapitelAus(best) } : null;
  }

  var api = {
    VERSION: VERSION,
    TEXT: TEXT,
    PRAEFIX: PRAEFIX,
    ZULETZT: ZULETZT,
    schluessel: schluessel,
    leererStand: leererStand,
    leseStand: leseStand,
    standText: standText,
    setzeFertig: setzeFertig,
    umschalten: umschalten,
    setzeAntworten: setzeAntworten,
    auswerten: auswerten,
    anzahlFertig: anzahlFertig,
    prozent: prozent,
    fortschrittText: fortschrittText,
    kartenText: kartenText,
    naechstesKapitel: naechstesKapitel,
    startText: startText,
    ergebnisText: ergebnisText,
    statusText: statusText,
    anfrageText: anfrageText,
    datumText: datumText,
    leseZuletzt: leseZuletzt,
    empfehlung: empfehlung,
    KONTO_PRAEFIX: KONTO_PRAEFIX,
    werkzeug: werkzeug,
    kontoStand: kontoStand,
    standAus: standAus,
    zuletztAus: zuletztAus
  };

  // Node (Tests): nur hier gibt es module.exports, im Browser nie
  if (typeof window === 'undefined' || typeof document === 'undefined') {
    if (typeof module === 'object' && module && module.exports) module.exports = api;
    return;
  }

  // ===========================================================================================
  // Teil 2: Browser
  // ===========================================================================================

  window.__mvSortiment = window.__mvSortiment || {};
  var MV = window.__mvSortiment;
  if (MV.akademie) return;

  // Seitenstand je Lernpfad: { stand, kapitel, aktualisiert_am } (Quelle MVKonto, danach die Aktionen der Seite)
  var cache = {};
  // Lernpfade, in denen auf dieser Seite eine Antwort gewaehlt wurde: ein Konto-Stand ersetzt dann keine offene Auswahl
  var beruehrt = {};
  // Lernpfade, deren Stand auf dieser Seite geaendert wurde (pruefen, Haken, zuruecksetzen): diese Aenderung gilt
  var geaendert = {};
  var druckt = false;

  function alle(bereich, selektor) {
    return Array.prototype.slice.call(bereich.querySelectorAll(selektor));
  }

  function setzeText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  // Verborgener Zusatz am Ende eines Links (Zustand fuer Screenreader, Paket T-1); leerer Text entfernt ihn
  function setzeZusatz(el, text) {
    if (!el) return;
    var z = el.querySelector('[data-mv-zustand-zusatz]');
    if (!text) {
      if (z) z.parentNode.removeChild(z);
      return;
    }
    if (!z) {
      z = document.createElement('span');
      z.className = 'mv-visually-hidden';
      z.setAttribute('data-mv-zustand-zusatz', '');
      el.appendChild(z);
    }
    setzeText(z, text);
  }

  function ruhig() {
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  // Konto-Schicht (assets/mv-sortiment.konto.js, Paket A-2a); im Buendel nach dieser Datei, darum erst beim Aufruf
  function konto() {
    var k = window.MVKonto;
    return k && typeof k.speichern === 'function' && typeof k.lesen === 'function' && typeof k.loeschen === 'function' ? k : null;
  }

  function istLeer(stand) {
    return !stand || (!fertigVon(stand).length && !Object.keys(antwortenVonStand(stand)).length);
  }

  function eintragAus(stand, aktualisiert_am) {
    return { stand: standAus(stand), kapitel: kapitelAus(stand), aktualisiert_am: typeof aktualisiert_am === 'string' ? aktualisiert_am : null };
  }

  // Stand des Lernpfads: einmal je Seite aus dem Browser-Spiegel (MVKonto.lokal, mit einmaliger Uebernahme der
  // Altstaende), danach aus dem Seitenstand
  function eintragVon(pfad) {
    if (hat(cache, pfad)) return cache[pfad];
    var k = konto();
    var e = null;
    if (k && typeof k.lokal === 'function') {
      try { e = k.lokal(werkzeug(pfad)); } catch (f) { e = null; }
    }
    cache[pfad] = eintragAus(e ? e.stand : null, e ? e.aktualisiert_am : null);
    return cache[pfad];
  }

  function lade(pfad) {
    return eintragVon(pfad).stand;
  }

  // Neuer Stand: sofort fuer die Seite, ueber MVKonto in den Browser und mit Login (entprellt) ins Konto
  function sichere(pfad, stand, kapitel, titel) {
    var k = KENNUNG.test(kapitel || '') ? kapitel : eintragVon(pfad).kapitel;
    cache[pfad] = { stand: kopie(stand), kapitel: k, aktualisiert_am: new Date().toISOString(), titel: titel || '' };
    geaendert[pfad] = true;
    var mv = konto();
    if (mv) mv.speichern(werkzeug(pfad), kontoStand(stand, titel, k));
  }

  function loesche(pfad) {
    cache[pfad] = { stand: leererStand(), kapitel: '', aktualisiert_am: null };
    geaendert[pfad] = true;
    var mv = konto();
    if (mv) mv.loeschen(werkzeug(pfad));
  }

  // Statuszeile binden; mit Login die Staende aus dem Konto holen und neu zeichnen, wenn sie abweichen
  // (zeichne bekommt die Handles mit neuem Inhalt; auch neue Zeitstempel zaehlen fuer "zuletzt bearbeitet")
  function kontoAbgleich(wurzel, handles, zeichne) {
    var mv = konto();
    if (!mv) return;
    var box = wurzel.querySelector('[data-mv-konto-hinweis]');
    if (box && typeof mv.hinweis === 'function') mv.hinweis(box, handles.map(werkzeug));
    if (wurzel.__mvAkademieKonto || typeof mv.eingeloggt !== 'function' || !mv.eingeloggt() || !handles.length) return;
    wurzel.__mvAkademieKonto = true;
    var inhalt = [];
    var zeit = false;
    var offen = handles.length;
    handles.forEach(function (h) {
      var p = null;
      try { p = mv.lesen(werkzeug(h)); } catch (f) { p = null; }
      var weiter = function () {
        offen -= 1;
        if (offen === 0 && (inhalt.length || zeit)) zeichne(inhalt);
      };
      if (!p || typeof p.then !== 'function') {
        weiter();
        return;
      }
      p.then(function (r) {
        if (!r) return;
        var alt = eintragVon(h);
        // auf dieser Seite schon geaendert (Konto-Stand trotzdem uebernommen, weil die Geraeteuhr nachgeht): die Aenderung
        // gilt und kommt wieder in den Spiegel
        if ((r.neu || r.verworfen) && geaendert[h]) {
          if (istLeer(alt.stand)) mv.loeschen(werkzeug(h));
          else mv.speichern(werkzeug(h), kontoStand(alt.stand, alt.titel, alt.kapitel));
          return;
        }
        if (r.neu || r.verworfen) {
          cache[h] = eintragAus(r.stand, r.aktualisiert_am);
          inhalt.push(h);
        } else if (r.quelle === 'konto' && r.aktualisiert_am && r.aktualisiert_am !== alt.aktualisiert_am) {
          alt.aktualisiert_am = r.aktualisiert_am;
          zeit = true;
        }
      }, function () { /* Konto nicht erreichbar: der Browser-Stand bleibt */ }).then(weiter, weiter);
    });
  }

  function kennungenVon(el, attr) {
    var roh = el.getAttribute(attr) || '';
    return roh ? roh.split(',').filter(function (k) { return KENNUNG.test(k); }) : [];
  }

  function sage(w, text) {
    setzeText(w.querySelector('[data-mv-lernpfad-ansage]'), text);
  }

  // ------------------------------------------------------------------------------- Lernpfad

  function kapitelVon(w, k) {
    return KENNUNG.test(k) ? w.querySelector('article[data-mv-lernpfad-kapitel="' + k + '"]') : null;
  }

  function fragenVon(form) {
    return alle(form, '[data-mv-lernpfad-frage]');
  }

  function richtigeVon(form) {
    return fragenVon(form).map(function (feld) {
      return parseInt(feld.getAttribute('data-mv-lernpfad-richtig'), 10) || 0;
    });
  }

  function antwortenVon(form) {
    return fragenVon(form).map(function (feld) {
      var r = feld.querySelector('input[type="radio"]:checked');
      return r ? parseInt(r.value, 10) || 0 : 0;
    });
  }

  function labelVon(feld, wert) {
    var r = feld.querySelector('input[type="radio"][value="' + wert + '"]');
    return r && r.closest ? r.closest('label') : null;
  }

  function optionText(feld, wert) {
    var l = labelVon(feld, wert);
    var t = l ? l.querySelector('[data-mv-lernpfad-option-text]') : null;
    return t ? t.textContent.replace(/[ \t\n\r\f]+/g, ' ').replace(/^ | $/g, '') : '';
  }

  function bewertungLoeschen(feld) {
    feld.removeAttribute('data-mv-lernpfad-bewertung');
    alle(feld, 'label').forEach(function (l) { l.removeAttribute('data-mv-lernpfad-bewertung'); });
    var r = feld.querySelector('[data-mv-lernpfad-rueckmeldung]');
    if (r) {
      r.hidden = true;
      setzeText(r, '');
    }
    var e = feld.querySelector('[data-mv-lernpfad-erklaerung]');
    if (e) e.hidden = true;
  }

  // Rueckmeldung je Frage: richtige Option markiert, falsch gewaehlte Option markiert, Erklaerung nur bei falsch
  function bewertungZeigen(form, antworten) {
    var richtige = richtigeVon(form);
    var erg = auswerten(antworten, richtige);
    fragenVon(form).forEach(function (feld, i) {
      bewertungLoeschen(feld);
      var ok = erg.je[i];
      feld.setAttribute('data-mv-lernpfad-bewertung', ok ? 'richtig' : 'falsch');
      var lr = labelVon(feld, richtige[i]);
      if (lr) lr.setAttribute('data-mv-lernpfad-bewertung', 'richtig');
      if (!ok && antworten[i]) {
        var lf = labelVon(feld, antworten[i]);
        if (lf) lf.setAttribute('data-mv-lernpfad-bewertung', 'falsch');
      }
      var r = feld.querySelector('[data-mv-lernpfad-rueckmeldung]');
      if (r) {
        setzeText(r, ok ? TEXT.richtig : fuelle(TEXT.falsch, { t: optionText(feld, richtige[i]) }));
        r.hidden = false;
      }
      var e = feld.querySelector('[data-mv-lernpfad-erklaerung]');
      if (e) e.hidden = ok;
    });
    form.setAttribute('data-mv-lernpfad-bewertung', erg.richtig === erg.gesamt ? 'richtig' : 'falsch');
    setzeText(form.querySelector('[data-mv-lernpfad-ergebnis]'), ergebnisText(erg.richtig, erg.gesamt));
    return erg;
  }

  // Gespeicherte Antworten in die Radiogruppen; vollstaendige Antworten gleich ausgewertet
  function antwortenSetzen(w, stand) {
    var a = antwortenVonStand(stand);
    alle(w, 'form[data-mv-lernpfad-test]').forEach(function (form) {
      var k = form.getAttribute('data-mv-lernpfad-test');
      var werte = hat(a, k) ? a[k] : null;
      fragenVon(form).forEach(function (feld, i) {
        bewertungLoeschen(feld);
        alle(feld, 'input[type="radio"]').forEach(function (r) {
          r.checked = !!werte && parseInt(r.value, 10) === werte[i];
        });
      });
      form.removeAttribute('data-mv-lernpfad-bewertung');
      setzeText(form.querySelector('[data-mv-lernpfad-ergebnis]'), '');
      if (werte && auswerten(werte, richtigeVon(form)).vollstaendig) bewertungZeigen(form, werte);
    });
  }

  function pfadAnwenden(w, stand) {
    var pfad = w.getAttribute('data-mv-lernpfad');
    var kennungen = kennungenVon(w, 'data-mv-lernpfad-kapitel');
    var s = stand || lade(pfad);
    var a = antwortenVonStand(s);
    var m = kennungen.length;
    var n = anzahlFertig(s, kennungen);

    alle(w, '[data-mv-lernpfad-fertig]').forEach(function (knopf) {
      var k = knopf.getAttribute('data-mv-lernpfad-fertig');
      var an = s.fertig.indexOf(k) !== -1;
      knopf.hidden = false;
      knopf.setAttribute('aria-pressed', an ? 'true' : 'false');
      var art = kapitelVon(w, k);
      if (!art) return;
      if (an) art.setAttribute('data-mv-lernpfad-zustand', 'fertig');
      else art.removeAttribute('data-mv-lernpfad-zustand');
      var status = art.querySelector('[data-mv-lernpfad-status]');
      if (status) status.hidden = !an;
    });
    alle(w, '[data-mv-lernpfad-leiste-ziel]').forEach(function (link) {
      var fertig = s.fertig.indexOf(link.getAttribute('data-mv-lernpfad-leiste-ziel')) !== -1;
      if (fertig) link.setAttribute('data-mv-lernpfad-zustand', 'fertig');
      else link.removeAttribute('data-mv-lernpfad-zustand');
      setzeZusatz(link, fertig ? TEXT.fertigZusatz : '');
    });
    alle(w, '[data-mv-lernpfad-pruefen]').forEach(function (b) { b.hidden = false; });
    alle(w, '[data-mv-lernpfad-aufloesung]').forEach(function (d) { d.hidden = true; });

    var p = prozent(n, m);
    var ring = w.querySelector('[data-mv-lernpfad-ring]');
    if (ring) {
      ring.hidden = false;
      ring.setAttribute('aria-valuenow', String(n));
      ring.setAttribute('aria-valuetext', fortschrittText(n, m));
    }
    var wert = w.querySelector('[data-mv-lernpfad-ring-wert]');
    if (wert) wert.setAttribute('stroke-dashoffset', String(100 - p));
    setzeText(w.querySelector('[data-mv-lernpfad-prozent]'), p + '\u00a0%');
    setzeText(w.querySelector('[data-mv-lernpfad-fortschritt]'), fortschrittText(n, m));

    var start = w.querySelector('[data-mv-lernpfad-start]');
    if (start) {
      var naechstes = naechstesKapitel(s, kennungen);
      setzeText(start.querySelector('[data-mv-lernpfad-start-text]'), startText(s, kennungen));
      start.setAttribute('href', naechstes ? '#kapitel-' + naechstes : '#lernstand');
    }

    // Lernstand: Zeile je Kapitel, Summe, Datum
    var box = w.querySelector('[data-mv-lernpfad-stand]');
    if (box) box.hidden = false;
    var richtigGesamt = 0;
    var fragenGesamt = 0;
    kennungen.forEach(function (k) {
      var art = kapitelVon(w, k);
      var form = art ? art.querySelector('form[data-mv-lernpfad-test]') : null;
      var richtige = form ? richtigeVon(form) : [];
      var erg = hat(a, k) && richtige.length ? auswerten(a[k], richtige) : null;
      fragenGesamt += richtige.length;
      if (erg && erg.vollstaendig) richtigGesamt += erg.richtig;
      var zeile = w.querySelector('[data-mv-lernpfad-stand-zeile="' + k + '"]');
      if (!zeile) return;
      if (s.fertig.indexOf(k) !== -1) zeile.setAttribute('data-mv-lernpfad-zustand', 'fertig');
      else zeile.removeAttribute('data-mv-lernpfad-zustand');
      setzeText(zeile.querySelector('[data-mv-lernpfad-stand-status]'), statusText(s, k));
      setzeText(zeile.querySelector('[data-mv-lernpfad-stand-fragen]'), erg && erg.vollstaendig ? ergebnisText(erg.richtig, erg.gesamt) : TEXT.ungeprueft);
    });
    setzeText(w.querySelector('[data-mv-lernpfad-stand-summe]'), fuelle(TEXT.summe, { k: fortschrittText(n, m), r: richtigGesamt, f: fragenGesamt }));
    setzeText(w.querySelector('[data-mv-lernpfad-datum]'), datumText(new Date()));

    var titel = w.getAttribute('data-mv-lernpfad-titel') || '';
    alle(w, '[data-mv-lernpfad-anfrage]').forEach(function (link) {
      link.setAttribute('data-konfiguration', anfrageText(titel, n, m));
    });
    var zurueck = w.querySelector('[data-mv-lernpfad-zuruecksetzen]');
    if (zurueck) zurueck.hidden = !(s.fertig.length || Object.keys(a).length);
    if (m > 0 && n >= m) w.setAttribute('data-mv-lernpfad-zustand', 'fertig');
    else w.removeAttribute('data-mv-lernpfad-zustand');
  }

  function nummerVon(w, k) {
    var art = kapitelVon(w, k);
    return art ? art.getAttribute('data-mv-lernpfad-nummer') || '' : '';
  }

  function pruefen(w, form) {
    var pfad = w.getAttribute('data-mv-lernpfad');
    var k = form.getAttribute('data-mv-lernpfad-test');
    if (!KENNUNG.test(k || '')) return;
    var antworten = antwortenVon(form);
    var erg = auswerten(antworten, richtigeVon(form));
    if (!erg.vollstaendig) {
      form.setAttribute('data-mv-lernpfad-bewertung', 'fehlt');
      setzeText(form.querySelector('[data-mv-lernpfad-ergebnis]'), TEXT.unvollstaendig);
      sage(w, TEXT.unvollstaendig);
      var offen = fragenVon(form).filter(function (feld, i) { return !antworten[i]; })[0];
      var r = offen ? offen.querySelector('input[type="radio"]') : null;
      if (r && typeof r.focus === 'function') r.focus();
      return;
    }
    bewertungZeigen(form, antworten);
    var s = setzeAntworten(lade(pfad), k, antworten);
    var komplett = erg.richtig === erg.gesamt;
    if (komplett) s = setzeFertig(s, k, true);
    sichere(pfad, s, k, w.getAttribute('data-mv-lernpfad-titel') || '');
    pfadAnwenden(w, s);
    var text = ergebnisText(erg.richtig, erg.gesamt) + '. ';
    sage(w, text + (komplett ? fuelle(TEXT.kapitelFertig, { n: nummerVon(w, k) }) : TEXT.erklaerungen));
  }

  function kapitelUmschalten(w, k) {
    if (!KENNUNG.test(k || '')) return;
    var pfad = w.getAttribute('data-mv-lernpfad');
    var kennungen = kennungenVon(w, 'data-mv-lernpfad-kapitel');
    var neu = umschalten(lade(pfad), k);
    sichere(pfad, neu, k, w.getAttribute('data-mv-lernpfad-titel') || '');
    pfadAnwenden(w, neu);
    var an = neu.fertig.indexOf(k) !== -1;
    var text = fuelle(an ? TEXT.kapitelFertig : TEXT.kapitelOffen, { n: nummerVon(w, k) });
    if (an && kennungen.length && anzahlFertig(neu, kennungen) >= kennungen.length) text += '. ' + TEXT.alle;
    sage(w, text);
  }

  function zuruecksetzen(w) {
    var pfad = w.getAttribute('data-mv-lernpfad');
    loesche(pfad);
    var s = leererStand();
    antwortenSetzen(w, s);
    pfadAnwenden(w, s);
    sage(w, TEXT.zurueck);
    var ziel = document.getElementById('lernstand-titel');
    if (ziel && typeof ziel.focus === 'function') ziel.focus();
  }

  // Sprung zu #ziel: scrollen, Fokus auf die Ueberschrift, Adresse ohne neuen Verlaufseintrag
  function springe(id) {
    var ziel = document.getElementById(id);
    if (!ziel) return false;
    if (typeof ziel.scrollIntoView === 'function') ziel.scrollIntoView({ behavior: ruhig() ? 'auto' : 'smooth', block: 'start' });
    var kopf = document.getElementById(id + '-titel') || ziel;
    if (typeof kopf.focus === 'function') {
      try { kopf.focus({ preventScroll: true }); } catch (e) { kopf.focus(); }
    }
    try { window.history.replaceState(null, '', '#' + id); } catch (e) { /* ohne History-API */ }
    return true;
  }

  // Drucken nur des Lernstands: Attribut an html, das Druck-CSS blendet alles andere aus; afterprint raeumt auf
  function drucke() {
    alle(document, '[data-mv-lernpfad-datum]').forEach(function (el) { setzeText(el, datumText(new Date())); });
    document.documentElement.setAttribute('data-mv-lernpfad-druck', '');
    druckt = true;
    if (typeof window.print === 'function') window.print();
    else nachDruck();
  }

  function nachDruck() {
    if (!druckt) return;
    druckt = false;
    document.documentElement.removeAttribute('data-mv-lernpfad-druck');
  }

  // Sichtbares Kapitel -> aria-current="step" in der Leiste; mobil den Eintrag in die Mitte der Liste schieben
  function setzeAktuell(w, k) {
    alle(w, '[data-mv-lernpfad-leiste-ziel]').forEach(function (a) {
      if (a.getAttribute('data-mv-lernpfad-leiste-ziel') !== k) {
        a.removeAttribute('aria-current');
        return;
      }
      a.setAttribute('aria-current', 'step');
      var liste = a.closest('[data-mv-lernpfad-leiste-liste]');
      if (!liste || liste.scrollWidth <= liste.clientWidth || !a.getBoundingClientRect) return;
      var r = a.getBoundingClientRect();
      var l = liste.getBoundingClientRect();
      var links = liste.scrollLeft + (r.left + r.width / 2) - (l.left + l.width / 2);
      if (typeof liste.scrollTo === 'function') liste.scrollTo({ left: links, behavior: ruhig() ? 'auto' : 'smooth' });
      else liste.scrollLeft = links;
    });
  }

  function beobachte(w) {
    if (typeof window.IntersectionObserver !== 'function' || w.__mvAkademieBeobachter) return;
    var ziele = alle(w, 'article[data-mv-lernpfad-kapitel]');
    if (!ziele.length) return;
    var beobachter = new window.IntersectionObserver(function (eintraege) {
      var oben = null;
      eintraege.forEach(function (e) {
        if (e.isIntersecting && (!oben || e.boundingClientRect.top < oben.boundingClientRect.top)) oben = e;
      });
      if (oben) setzeAktuell(w, oben.target.getAttribute('data-mv-lernpfad-kapitel'));
    }, { rootMargin: '-30% 0px -60% 0px' });
    ziele.forEach(function (z) { beobachter.observe(z); });
    w.__mvAkademieBeobachter = beobachter;
  }

  function pfadStarten(w) {
    var pfad = w.getAttribute('data-mv-lernpfad');
    var s = lade(pfad);
    antwortenSetzen(w, s);
    pfadAnwenden(w, s);
    beobachte(w);
    w.setAttribute('data-mv-akademie-bereit', VERSION);
    // A-2a: Stand aus dem Konto; Antworten nur setzen, solange auf der Seite noch nichts gewaehlt wurde
    kontoAbgleich(w, [pfad], function (inhalt) {
      if (inhalt.indexOf(pfad) === -1) return;
      var neu = lade(pfad);
      if (!beruehrt[pfad]) antwortenSetzen(w, neu);
      pfadAnwenden(w, neu);
    });
  }

  // ------------------------------------------------------------------------------- Hub

  function ringSetzen(karte, n, m) {
    var p = prozent(n, m);
    var ring = karte.querySelector('[data-mv-akademie-ring]');
    if (ring) {
      ring.hidden = n === 0;
      ring.setAttribute('aria-valuenow', String(n));
      ring.setAttribute('aria-valuetext', kartenText(n, m));
    }
    var wert = karte.querySelector('[data-mv-akademie-ring-wert]');
    if (wert) wert.setAttribute('stroke-dashoffset', String(100 - p));
    setzeText(karte.querySelector('[data-mv-akademie-prozent]'), p + '\u00a0%');
  }

  function hubStarten(h) {
    var pfade = [];
    var staende = {};
    var summeN = 0;
    var summeM = 0;
    alle(h, '[data-mv-akademie-karte]').forEach(function (karte) {
      var pfad = karte.getAttribute('data-mv-akademie-karte') || '';
      if (!KENNUNG.test(pfad)) return;
      var kennungen = kennungenVon(karte, 'data-mv-akademie-kapitel');
      var s = lade(pfad);
      var n = anzahlFertig(s, kennungen);
      var m = kennungen.length;
      pfade.push({ handle: pfad, kapitel: kennungen, karte: karte });
      staende[pfad] = s;
      summeN += n;
      summeM += m;
      ringSetzen(karte, n, m);
      var text = karte.querySelector('[data-mv-akademie-karte-fortschritt]');
      if (text) {
        text.hidden = n === 0;
        setzeText(text, n ? kartenText(n, m) : '');
      }
      alle(karte, '[data-mv-akademie-eintrag]').forEach(function (li) {
        var fertig = s.fertig.indexOf(li.getAttribute('data-mv-akademie-eintrag')) !== -1;
        if (fertig) li.setAttribute('data-mv-akademie-zustand', 'fertig');
        else li.removeAttribute('data-mv-akademie-zustand');
        setzeZusatz(li.querySelector('a') || li, fertig ? TEXT.fertigZusatz : '');
      });
      if (n === 0) karte.removeAttribute('data-mv-akademie-zustand');
      else karte.setAttribute('data-mv-akademie-zustand', n >= m ? 'fertig' : 'begonnen');
      var link = karte.querySelector('[data-mv-akademie-karte-link]');
      var url = karte.getAttribute('data-mv-akademie-url') || '';
      if (link && url) {
        var naechstes = naechstesKapitel(s, kennungen);
        var knopf = link.querySelector('[data-mv-akademie-karte-text]');
        if (!link.hasAttribute('data-mv-akademie-text')) link.setAttribute('data-mv-akademie-text', knopf ? knopf.textContent : '');
        setzeText(knopf, n === 0 ? link.getAttribute('data-mv-akademie-text') : naechstes ? TEXT.weiterlernen : TEXT.ansehen);
        link.setAttribute('href', n === 0 ? url : url + (naechstes ? '#kapitel-' + naechstes : '#lernstand'));
      }
    });

    var weiter = h.querySelector('[data-mv-akademie-weiter]');
    if (weiter) {
      var gesamt = weiter.querySelector('[data-mv-akademie-gesamt]');
      if (gesamt) {
        gesamt.hidden = summeN === 0;
        setzeText(gesamt, summeN ? fuelle(TEXT.gesamt, { n: summeN, m: summeM }) : '');
      }
      var e = empfehlung(pfade, staende, zuletztAus(pfade.map(function (p) {
        var x = eintragVon(p.handle);
        return { pfad: p.handle, kapitel: x.kapitel, aktualisiert_am: x.aktualisiert_am };
      })));
      if (e) {
        var titelEl = weiter.querySelector('[data-mv-akademie-weiter-titel]');
        var textEl = weiter.querySelector('[data-mv-akademie-weiter-text]');
        var linkEl = weiter.querySelector('[data-mv-akademie-weiter-link]');
        var knopfEl = weiter.querySelector('[data-mv-akademie-weiter-knopf]');
        var ziel = null;
        pfade.forEach(function (p) { if (p.handle === e.pfad) ziel = p; });
        if (ziel) {
          var eintrag = ziel.karte.querySelector('[data-mv-akademie-eintrag="' + e.kapitel + '"] [data-mv-akademie-eintrag-text]');
          setzeText(titelEl, fuelle(TEXT.weiterTitel, { t: ziel.karte.getAttribute('data-mv-akademie-titel') || '' }));
          setzeText(textEl, fuelle(TEXT.weiterKapitel, { n: e.nummer, t: eintrag ? eintrag.textContent.replace(/^[ \t\n\r\f]+|[ \t\n\r\f]+$/g, '') : '' }));
          if (linkEl) linkEl.setAttribute('href', (ziel.karte.getAttribute('data-mv-akademie-url') || '') + '#kapitel-' + e.kapitel);
          setzeText(knopfEl, TEXT.weiterlernen);
          weiter.setAttribute('data-mv-akademie-zustand', 'begonnen');
        } else if (!e.pfad && pfade.length) {
          setzeText(titelEl, TEXT.alleFertigTitel);
          setzeText(textEl, TEXT.alleFertigText);
          if (linkEl) linkEl.setAttribute('href', (pfade[0].karte.getAttribute('data-mv-akademie-url') || '') + '#lernstand');
          setzeText(knopfEl, TEXT.ansehen);
          weiter.setAttribute('data-mv-akademie-zustand', 'fertig');
        }
      }
    }
    h.setAttribute('data-mv-akademie-bereit', VERSION);
    // A-2a: Statuszeile fuer alle Lernpfade; mit Login die Staende aus dem Konto, danach einmal neu zeichnen
    kontoAbgleich(h, pfade.map(function (p) { return p.handle; }), function () { hubStarten(h); });
  }

  // ------------------------------------------------------------------------------- Start und Ereignisse

  function starten(bereich) {
    if (!bereich || !bereich.querySelectorAll) return;
    var wurzeln = alle(bereich, '[data-mv-akademie]');
    if (bereich.matches && bereich.matches('[data-mv-akademie]')) wurzeln.unshift(bereich);
    wurzeln.forEach(function (w) {
      var art = w.getAttribute('data-mv-akademie');
      if (art === 'pfad' && KENNUNG.test(w.getAttribute('data-mv-lernpfad') || '')) pfadStarten(w);
      else if (art === 'hub') hubStarten(w);
    });
  }

  // Stand neu lesen, ohne offene Auswahl in den Fragen zu verwerfen (Zurueck-Taste, anderer Tab)
  function auffrischen() {
    alle(document, '[data-mv-akademie]').forEach(function (w) {
      var art = w.getAttribute('data-mv-akademie');
      if (art === 'pfad' && KENNUNG.test(w.getAttribute('data-mv-lernpfad') || '')) pfadAnwenden(w);
      else if (art === 'hub') hubStarten(w);
    });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var w = t.closest('[data-mv-akademie="pfad"]');
    if (!w) return;
    var knopf = t.closest('[data-mv-lernpfad-fertig]');
    if (knopf) {
      e.preventDefault();
      kapitelUmschalten(w, knopf.getAttribute('data-mv-lernpfad-fertig'));
      return;
    }
    if (t.closest('[data-mv-lernpfad-zuruecksetzen]')) {
      e.preventDefault();
      zuruecksetzen(w);
      return;
    }
    if (t.closest('[data-mv-lernpfad-drucken]')) {
      e.preventDefault();
      drucke();
      return;
    }
    var weg = t.closest('[data-mv-lernpfad-leiste-ziel], [data-mv-lernpfad-start], [data-mv-lernpfad-gehe]');
    if (weg) {
      var href = weg.getAttribute('href') || '';
      if (href.charAt(0) === '#' && href.length > 1 && springe(href.slice(1))) e.preventDefault();
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-mv-lernpfad-test]')) return;
    var w = form.closest('[data-mv-akademie="pfad"]');
    if (!w) return;
    e.preventDefault();
    pruefen(w, form);
  });

  // Neue Auswahl: Rueckmeldung dieser Frage und das Ergebnis des Kapitels gelten nicht mehr
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.matches || !t.matches('[data-mv-lernpfad-frage] input[type="radio"]')) return;
    var w = t.closest('[data-mv-akademie="pfad"]');
    if (w) beruehrt[w.getAttribute('data-mv-lernpfad') || ''] = true;
    var feld = t.closest('[data-mv-lernpfad-frage]');
    var form = t.closest('form[data-mv-lernpfad-test]');
    if (feld) bewertungLoeschen(feld);
    if (form) {
      form.removeAttribute('data-mv-lernpfad-bewertung');
      setzeText(form.querySelector('[data-mv-lernpfad-ergebnis]'), '');
    }
  });

  window.addEventListener('afterprint', nachDruck);

  // Zurueck-Taste (bfcache): Staende neu aus dem Browser-Spiegel lesen
  window.addEventListener('pageshow', function (e) {
    if (!e || !e.persisted) return;
    cache = {};
    auffrischen();
  });

  // Anderer Tab: MVKonto meldet geaenderte Spiegel (Ereignis extern); nur die Lernpfade neu lesen
  var hoert = false;
  function kontoHoeren() {
    var mv = konto();
    if (hoert || !mv || typeof mv.on !== 'function') return;
    hoert = true;
    mv.on('extern', function (d) {
      var w = d && typeof d.werkzeug === 'string' ? d.werkzeug : '';
      if (w.indexOf(KONTO_PRAEFIX) !== 0) return;
      delete cache[w.slice(KONTO_PRAEFIX.length)];
      auffrischen();
    });
  }

  document.addEventListener('shopify:section:load', function (e) {
    starten(e.target);
  });

  api.starten = starten;
  MV.akademie = api;

  function bereit() {
    kontoHoeren();
    starten(document);
  }

  // A-2a: MVKonto steht im Buendel nach dieser Datei (konkat.sh, alphabetisch); mit defer laeuft das Buendel bei
  // readyState "interactive" - erst nach dem ganzen Buendel starten (Mikrotask, vor dem naechsten Zeichnen)
  function nachBuendel(fn) {
    if (window.MVKonto || typeof window.Promise !== 'function') fn();
    else window.Promise.resolve().then(fn);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { nachBuendel(bereit); });
  else nachBuendel(bereit);
})();
